import i18n from "i18n"
import { routes } from "router/routes"
import { isFeatureEnabled } from "config/features"
import { generateGuideProfileUrl } from "utils/host-urls"
import { MODULES } from "utils/permissions"

export const proMenuKeys = {
  dashboard: "dashboard",
  bookings: "bookings",
  clients: "clients",
  messages: "messages",
  marketing: "marketing",
  accounting: "accounting",
  resources: "resources",
  experiences: "experiences",
  settings: "settings",
  guidePreview: "preview",
  faqs: "faqs",
  contactSupport: "contact-support",
  calendar: "calendar",
  staff : "staff"
}

const getMenuItems = () => {
  const items = []

  // Only show Dashboard menu if AI_DASHBOARD feature is enabled
  if (isFeatureEnabled("AI_DASHBOARD")) {
    items.push({
      name: i18n.t("pro.sidebar.menu.dashboard"),
      path: routes.guideAIDashboardPath(),
      id: proMenuKeys.dashboard,
      iconName: "dashboard"
    })
  }

  // Always show other menu items
  items.push(
    {
      name: i18n.t("pro.sidebar.menu.calendar"),
      path: routes.proCalendarPath(),
      id: proMenuKeys.calendar,
      iconName: "calendar",
      requiredModule: MODULES.CALENDAR
    },
    {
      name: i18n.t("pro.sidebar.menu.bookings"),
      path: routes.guideBookingsPath(),
      id: proMenuKeys.bookings,
      iconName: "booking",
      requiredModule: MODULES.BOOKINGS
    },
    {
      name: i18n.t("pro.sidebar.menu.clients"),
      path: routes.guideClientsPath(),
      id: proMenuKeys.clients,
      iconName: "user",
      requiredModule: MODULES.CLIENTS
    },
    {
      name: i18n.t("pro.sidebar.menu.messages"),
      path: routes.guideMessagesPath(),
      id: proMenuKeys.messages,
      iconName: "messages",
      requiredModule: MODULES.MESSAGES
    },
    {
      name: i18n.t("pro.sidebar.menu.marketing"),
      path: routes.guideMarketingPath(),
      id: proMenuKeys.marketing,
      iconName: "marketing",
      requiredModule: MODULES.MARKETING
    },
    {
      name: i18n.t("pro.sidebar.menu.accounting"),
      path: routes.guideAccountingPath(),
      id: proMenuKeys.accounting,
      iconName: "finances",
      requiredModule: MODULES.ACCOUNTING
    },
    {
      name: i18n.t("pro.sidebar.menu.resources"),
      path: isFeatureEnabled("NEW_RESOURCES") ? routes.guideResourcesPath() : routes.guideBoatsPath(),
      id: isFeatureEnabled("NEW_RESOURCES") ? proMenuKeys.resources : "boats",
      iconName: "boat",
      requiredModule: isFeatureEnabled("NEW_RESOURCES") ? MODULES.EQUIPMENT : null
    },
    {
      name: i18n.t("pro.sidebar.menu.experiences"),
      path: routes.proExperiencesPath(),
      id: proMenuKeys.experiences,
      iconName: "experiences",
      requiredModule: MODULES.EXPERIENCES
    }
  )

  return items
}

export const proMenuList = [
  {
    groupName: i18n.t("pro.sidebar.menu.title"),
    id: "menu",
    items: getMenuItems()
  },
  {
    groupName: i18n.t("pro.sidebar.account.title"),
    id: "account",
    items: [
      {
        name: i18n.t("pro.sidebar.account.settings"),
        path: routes.proSettingsRootPath(),
        id: proMenuKeys.settings,
        iconName: "settings"
      },
      {
        name: i18n.t("pro.sidebar.account.staff"),
        path: routes.proStaffPath(),
        id: proMenuKeys.staff,
        iconName: "staffManagement",
        requiredModule: MODULES.STAFF
      },
      {
        name: i18n.t("pro.sidebar.account.preview"),
        path: (params) => generateGuideProfileUrl(params.slug),
        id: proMenuKeys.guidePreview,
        iconName: "Play",
        iconType: "feather",
        openInNewTab: true
      }
    ]
  },
  {
    groupName: i18n.t("pro.sidebar.help.title"),
    id: "help",
    items: [
      {
        name: i18n.t("pro.sidebar.help.faqs"),
        path: routes.guideFaqPath(),
        id: proMenuKeys.faqs,
        iconName: "faq"
      },
      {
        name: i18n.t("pro.sidebar.help.contact_support"),
        path: routes.contactSupportPath(),
        id: proMenuKeys.contactSupport,
        iconName: "support"
      }
    ]
  }
]
